module.exports = __webpack_public_path__ + "static/fkt-5f240afd053eebc8130ac41f691a066e.png";